<template>
	<div style="width: 100%;height: 100%;" class="chart">

	</div>
</template>

<script>
	import echarts from 'echarts'

	function setOption(args) {
		var option = {
			xAxis: {
				type: 'category',
				data:args.xData ,
				axisLine: {
					show: true,
					lineStyle: {
						color: '#57617B', //坐标轴线线的颜色。
						width: 1,
            			type: "solid"
					}
				},
				axisLabel: {
					rotate:18,
					textStyle: {
						// color: '#c3dbff',  //更改坐标轴文字颜色
						fontSize : 10      //更改坐标轴文字大小
        			}
				},
			},
			tooltip:{
        		trigger:'axis',
        		axisPointer:{
          			type:'shadow'
        		}
      		},
			grid: {
				left: '2.5%', //grid 组件离容器左侧的距离。
				right: '2.5%', //grid 组件离容器右侧的距离。
				top:'4%',
				bottom: '4%', //grid 组件离容器下侧的距离。
				containLabel: true //grid 区域是否包含坐标轴的刻度标签[ default: false ] 
			},
			color: args.colorList?args.colorList:["#e07072","#f7b84f","#faf896","#7de7fa"],
			label: {
		        show: true,
		        position: 'top',
		        color: '#333',
		        fontSize: 14,
		        fontWeight: 700
		    },
			yAxis: {
				type: 'value',
				axisLine: {
					show: true,
					lineStyle: {
						color: 'rgba(81,177,203,1)' //坐标轴线线的颜色
					}
		    	},
				splitLine: {
					show: false,
					lineStyle:{
						color:'rgba(81,177,203,1)',
						type:'dotted'
					}
				},
				axisLabel: {
					color:'#57617B'
				},
			},
			// dataZoom: [
			// 	{
			// 		type: 'slider',
			// 		dataBackground: {
			// 			lineStyle: {
			// 				color: '#69b8e3',
			// 				width: 1,
			// 			},
			// 			areaStyle: {
			// 				color: {
			// 					type: 'linear',
			// 					x: 0,
			// 					y: 0,
			// 					x2: 0,
			// 					y2: 1,
			// 					colorStops: [
			// 						{
			// 							offset: 0, color: '#F3F9FD' // 0% 处的颜色
			// 						}, {
			// 							offset: 1, color: '#69b8e3' // 100% 处的颜色
			// 						}
			// 					],
			// 					globalCoord: false // 缺省为 false
			// 				}
			// 			},
			// 		},
			// 		fillerColor: 'rgba(43, 154, 215, 0.2)',
			// 		borderColor: '#E2EEF4',
			// 		handleSize: '30%',
			// 		handleStyle: {
			// 			color: '#69b8e3'
			// 		},
			// 		bottom: 2
      //   }, {
			// 		type: 'inside',
			// 		start: 0,
			// 		end: 40
      // 	}
			// ],
			// series: [5, 20, 36, 10, 10, 20],
			series: [{
				name: args.yData.name,
				data:args.yData.data,
				type: 'bar',
				//设置柱子的宽度
				barMaxWidth : 15,
				label:{
          		show:false
        		}
				},
			// 	{
			// 	name: args.yData[1].name,
			// 	data: args.yData[1].data,
			// 	type: 'bar',
			// 	//设置柱子的宽度
			// 	barMaxWidth : 15,
			// 	label:{
          	// 	show:false
        	// 	}
			// 	},{
			// 	name: args.yData[2].name,
			// 	data:args.yData[2].data,
			// 	type: 'bar',
			// 	//设置柱子的宽度
			// 	barMaxWidth : 15,
			// 	label:{
          	// 	show:false
        	// 	}
			// 	},{
			// 	name: args.yData[3].name,
			// 	data:args.yData[3].data,
			// 	type: 'bar',
			// 	//配置样式
			// 	// itemStyle: {
			// 	// 	//通常情况下：
			// 	// 	normal: {　　　　　　　　　　　　 //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
			// 	// 		color: function(params) {
			// 	// 			var colorList = ['#F86B4F', '#FF9C00', '#FFC602', '#2DBDEF','#8B8A88'];
			// 	// 			return colorList[params.dataIndex];
			// 	// 		}
			// 	// 	},
			// 	// },
			// 	//设置柱子的宽度
			// 	barMaxWidth : 15,
			// 	label:{
          	// 	show:false
        	// 	}
			// }
			]
		};

		return option;
	}
	export default {
		name: 'CsBar',
		props: ['args'],
		methods: {
			initChart() {
        let _this = this
				window.addEventListener('resize', function() {
					this.myChart.resize()
				}.bind(this))
			},
			resize: function() {
				this.myChart.resize()
			},
			reDrawChart: function(args) {
				var container = this.$el;
			  console.log(container)
				this.initChart();
				this.myChart = echarts.init(container);
				this.myChart.setOption(setOption(args), false);
			}
		},
		mounted: function(el) {
		}

	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/echarts/barChart.vue